import { call, put, takeEvery } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import {
  CustomerStitchStartFlow,
  CustomerStitchCompletePayment,
  FetchCustomerProfile,
  FetchUser,
} from 'src/constants/actionTypes'
import { ApiService, callSecureApi } from '../api/callApi'
import { Endpoints } from 'src/constants/endpoints'

interface CustomerStitchStartFlowResponse {
  token: string
}

function* onCustomerStitchStartFlow(action: AsyncAction<void, CustomerStitchStartFlowResponse>) {
  try {
    const { payload }: { payload: CustomerStitchStartFlowResponse } = yield call(
      callSecureApi,
      Endpoints.CustomerStitchStartFlow,
      {
        apiService: ApiService.Paraworks,
        method: 'POST',
      },
    )

    yield put(CustomerStitchStartFlow.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to fetch stitch token'

    yield put(CustomerStitchStartFlow.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

function* onCustomerStitchCompletePayment(action: AsyncAction) {
  try {
    // yield call(callSecureApi, Endpoints.CustomerStitchCompletePayment, {
    //   apiService: ApiService.Paraworks,
    //   method: 'POST',
    // })

    yield put(CustomerStitchCompletePayment.success())
    yield put(FetchUser.request())
    yield put(FetchCustomerProfile.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to complete payment'

    yield put(CustomerStitchCompletePayment.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* customerStitchSaga() {
  yield takeEvery(CustomerStitchStartFlow.type.REQUEST, onCustomerStitchStartFlow)
  yield takeEvery(CustomerStitchCompletePayment.type.REQUEST, onCustomerStitchCompletePayment)
}
